import * as types from "./mutations-types";

export default {
    [types.SET_CUSTOMERS_LIST](state, list) {
        state.customers_list = list;
    }
};
